const state = {
  list: [],
  isLoading: false,
  isUploading: false,
  isPaginating: false,
  hasEmpty: false,
  filter: {},
  header: [],
  all: [],
  isShowLoading: false,
};

export default state;
